import React from 'react';

export const showPasswordIcon = {
  show: <u>Hide</u>,
  hide: <u>Show</u>,
};
